import { POST_WITH_ID } from '@brickwise/asset-validation';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageViewList } from 'src/components/ui/ImageViewList';
import { UploadDropzone } from 'src/components/ui/UploadDropzone';

interface Props {
  disabled?: boolean;
}

export const LocationPhotosImageSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext<POST_WITH_ID>();

  const locationPhotos = formik.values.images?.locationPhotos || [];

  return (
    <div>
      <label>{t('dashboard.assets.addedit.main.locationandproperty.text.locationphotos')}</label>
      <div>
        <UploadDropzone
          disabled={disabled}
          imageUploaded={(url: string, name: string) => {
            formik.setFieldValue('images.locationPhotos', [
              ...locationPhotos,
              {
                src: url,
                name,
              },
            ]);
          }}
        />
        <ImageViewList disabled={disabled} data={locationPhotos} setData={(data) => formik.setFieldValue('images.locationPhotos', data)} />
      </div>
    </div>
  );
};
